const URGENT = 'Urgent';
const PENDING = 'Pending';

const JobFlags = {
    URGENT,
    PENDING
};

export { JobFlags };